








import { Vue, Prop, Component } from 'vue-property-decorator'
@Component({
  name: 'MainTitle'
})
export default class extends Vue {
  @Prop({ required: true }) private title!: string
  @Prop({ default: '' }) private tag!: string
}
